import axios from 'axios';

import API_HOST from '../api';

/**
 * auditLogApi
 *
 * @description http functions for interacting with the audit log
 *
 * @param API_HOST - base api host name minus /api part
 *
 * @returns {auditLogApi}
 */
export var auditLogApi = function() {
  const self = {};
  /**
   * @interface AuditLogApi
   */

  /**
   *  @typeof auditLogApi
   *  @implements AuditLogApi
   */

  /**
   * query
   *
   * @function
   * @description query the audit log list with search params
   * @memberof AuditLogApi
   *
   * @returns {Promise}
   */
  self.query = function(form) {
    const url = `${API_HOST}/api/audit-log-list`;

    return axios.post(url, form);
  };

  /**
   * getById
   *
   * @function
   * @description request audit log by audit logs id
   * @memberof AuditLogApi
   *
   * @param id {Number} - audit logs id
   * @returns {Promise}
   */
  self.getById = function(clientId, id) {
    const url = `${API_HOST}/api/client/${clientId}/audit-log/${id}`;

    return axios.get(url);
  };

  self.getRelated = function(clientId, id, limit) {
    const url = `${API_HOST}/api/client/${clientId}/audit-log/${id}/related-list?limit=${limit}`;

    return axios.get(url);
  };

  /**
   * getSubjects
   *
   * @function
   * @description request audit log subjects
   * @memberof AuditLogApi
   *
   * @returns {Promise}
   */
  self.getSubjects = function() {
    const url = `${API_HOST}/api/audit/subject-list`;

    return axios.get(url);
  };

  /**
   * getActions
   *
   * @function
   * @description request audit log actions
   * @memberof AuditLogApi
   *
   * @returns {Promise}
   */
  self.getActions = function() {
    const url = `${API_HOST}/api/audit/action-list`;

    return axios.get(url);
  };

  self.getClients = function(search, limit) {
    const query = `?filter=${search}&limit=${limit}`;
    const url = `${API_HOST}/api/audit/client-list${query}`;

    return axios.get(url);
  };

  self.getUsers = function(clientId, search, limit) {
    const query = `?filter=${search}&limit=${limit}`;
    const url = `${API_HOST}/api/client/${clientId}/audit-user-list${query}`;

    return axios.get(url);
  };

  return self;
};

export default auditLogApi();
